import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=242aa857&scoped=true"
import script from "./UploadImageModal.vue?vue&type=script&lang=js"
export * from "./UploadImageModal.vue?vue&type=script&lang=js"
import style0 from "./UploadImageModal.vue?vue&type=style&index=0&id=242aa857&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242aa857",
  null
  
)

export default component.exports